import axios from 'axios'

//const baseUrl= 'http://localhost:3001/persons'
const baseUrl = '/api/persons' //'http://localhost:3001/api/persons'  //for part3

const getAll = () => {
    return axios.get(baseUrl).then(response => response.data)
  }

const create = (newPerson) => {
    return axios.post(baseUrl, newPerson).then(response => response.data)
  }

const remove = id => {
    return axios.delete(`${baseUrl}/${id}`)
  }

const update = (id, updatedPerson) => {
    return axios.put(`${baseUrl}/${id}`, updatedPerson).then(response => response.data)
  }

export default { getAll, create, remove, update }